import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import '../../assets/css/Leads.css'
import { Offcanvas } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";


const Report = () => {
  const [leads, setLeads] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(50); const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [serviceBoy, setServiceBoy] = useState([]);
  const [page, setPage] = useState(1);

  const imageUrl = "https://devapi.bykit.in/storage/users/";
  const invoiceUrl = "https://devapi.bykit.in/storage/brands/";

  useEffect(() => {
    getLeadsData();
    ServiceBoyData();
  }, []);


  const offcanvasRef = useRef(null);



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showOffcanvas &&
        offcanvasRef.current &&
        !offcanvasRef.current.contains(event.target)
      ) {
        setShowOffcanvas(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showOffcanvas]);

  const handleShowDetails = (lead) => {
    setSelectedLead(lead);
    setShowOffcanvas(true);
  };

  const ServiceBoyData = async () => {
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    try {
      const response = await axios.get(
        `https://devapi.bykit.in/api/admin/get_delivery_boys??type=live`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log('ServiceBoyData', response.data.data)

      if (response.data && response.data.data) {
        setServiceBoy(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const labels = [
    "Meter",
    "Front Angle",
    "Right angle",
    "Left angle",
    "Back side",
    "Any dent/scratches"
  ];

  let formattedPickupTime = ''
  if (selectedLead && selectedLead.pickup_time) {
    const pickup = new Date(selectedLead.pickup_time);
    formattedPickupTime = `${String(pickup.getDate()).padStart(2, '0')}-${String(pickup.getMonth() + 1).padStart(2, '0')}-${pickup.getFullYear()} ${String(pickup.getHours()).padStart(2, '0')}:${String(pickup.getMinutes()).padStart(2, '0')}`;
  }

  let formattedreachedTime = ''
  if (selectedLead && selectedLead.reached_workshop_time) {
    const reached = new Date(selectedLead.reached_workshop_time);
    formattedreachedTime = `${String(reached.getDate()).padStart(2, '0')}-${String(reached.getMonth() + 1).padStart(2, '0')}-${reached.getFullYear()} ${String(reached.getHours()).padStart(2, '0')}:${String(reached.getMinutes()).padStart(2, '0')}`;
  }

  let formattestartTime = ''
  if (selectedLead && selectedLead.start_service_time) {
    const start = new Date(selectedLead.start_service_time);
    formattestartTime = `${String(start.getDate()).padStart(2, '0')}-${String(start.getMonth() + 1).padStart(2, '0')}-${start.getFullYear()} ${String(start.getHours()).padStart(2, '0')}:${String(start.getMinutes()).padStart(2, '0')}`;
  }

  let formattecompleteTime = ''
  if (selectedLead && selectedLead.service_complete_time) {
    const complete = new Date(selectedLead.service_complete_time);
    formattecompleteTime = `${String(complete.getDate()).padStart(2, '0')}-${String(complete.getMonth() + 1).padStart(2, '0')}-${complete.getFullYear()} ${String(complete.getHours()).padStart(2, '0')}:${String(complete.getMinutes()).padStart(2, '0')}`;
  }

  let formatteDropTime = ''
  if (selectedLead && selectedLead.drop_time) {
    const drop = new Date(selectedLead.drop_time);
    formatteDropTime = `${String(drop.getDate()).padStart(2, '0')}-${String(drop.getMonth() + 1).padStart(2, '0')}-${drop.getFullYear()} ${String(drop.getHours()).padStart(2, '0')}:${String(drop.getMinutes()).padStart(2, '0')}`;
  }


  let insuranceexpiry = ''
  if (selectedLead && selectedLead.insurance_expiry_date) {
    const drop = new Date(selectedLead.insurance_expiry_date);
    insuranceexpiry = `${String(drop.getDate()).padStart(2, '0')}-${String(drop.getMonth() + 1).padStart(2, '0')}-${drop.getFullYear()}`;
  }


  const getLeadsData = async () => {
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    const url = "https://devapi.bykit.in/api/admin/getallbooking??type=live"
    const payload = {
      user_id: 1
    }
    try {
      const response = await axios.post(url, payload, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("All Bookings:", response.data);

      if (response.data?.data) {
        const filteredLeads = response.data.data.filter(
          (item) => item.status != 20
        );

        setLeads(filteredLeads);
      }

    } catch (error) {
      console.error("Error fetching data:", error.response?.data || error.message);
    }
  };



  const columns = [
    {
      name: "Service Date",
      cell: (row) => (
        <div>
          <p>{row.date || "N/A"}</p>
          <span className={`text-white font-bold ${row.status === 0 ? "deactvie_btn" : "active_btn"}`}>
            {row.status === 0 ? "Deactive" : "Active"}
          </span>
        </div>
      ),
      sortable: true
    },

    { name: "Customer Name", selector: (row) => row.customer_name || "N/A", sortable: true },
    { name: "Email", selector: (row) => row.email || "N/A", sortable: true },
    { name: "Phone", selector: (row) => row.phone || "N/A", sortable: true },
    { name: "Vehicle Number", selector: (row) => row.vehicle_name || "N/A", sortable: true },
    { name: "Invoice Amount", selector: (row) => row.invoice_amount || "N/A", sortable: true },
    {
      name: "Action",
      cell: (row, index) => (
        <div className="d-flex justify-content-end">
          <button className="edit_btn me-2"
            data-tooltip-id={`view-tooltip-${row.id}`}
            data-tooltip-content="View Details"
            onClick={() => handleShowDetails(row)}>
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="me-1 iconify iconify--heroicons" width="1em" height="1em" viewBox="0 0 24 24">
              <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                <path d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178c.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178"></path>
                <path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0"></path>
              </g>
            </svg>
          </button>
          <Tooltip id={`view-tooltip-${row.id}`} place="top" className="tooltip_bg" />

        </div>
      ),
    },
  ];

  // -------------------------filter-------------------------------------


  const [selectedserviceboy, setSelectedServiceboy] = useState(null);
  const [filteredLeads, setFilteredLeads] = useState([]);

  const handleWorkshopSelect = (workshop) => {
    setSelectedServiceboy(workshop);

    console.log("Selected Service boy:", workshop);
    console.log("ID:", workshop.id);


    const matchedLeads = leads.filter((lead) => lead.delivery_assigned_to === workshop.id);
    setFilteredLeads(matchedLeads);

    console.log("Filtered Leads:", matchedLeads);
  };

  return (
    <div className="container data-table-container p-2">
      {!showForm && (
        <div>
          <div className="d-flex align-items-center gap-3">
            <svg className="custom-icon" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="20px" height="20px" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m3 12l2-2m0 0l7-7l7 7M5 10v10a1 1 0 0 0 1 1h3m10-11l2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"></path>
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="18px" height="18px" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m8.25 4.5l7.5 7.5l-7.5 7.5"></path>
            </svg>

            <p className="m-0">All Bookings</p>
          </div>
          <div className='managebrand_box mt-3 mb-2 pt-4 pb-1'>
            <div>
              <h4 className='dashboard_head ps-3 pb-4'>All Bookings</h4>
            </div>
            <hr></hr>
            <div className="d-flex justify-content-between my-3 px-3">
              <div className="dropdown">
                <button
                  className="btn dropdown-toggle dropdown_workshop text-light fw-bold"
                  type="button"
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false">
                  Select Delivery Boy
                </button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  {serviceBoy.length > 0 ? (
                    serviceBoy.map((serviceBoy) => (
                      <li key={serviceBoy.id}>
                        <button
                          className="dropdown-item" onClick={() => handleWorkshopSelect(serviceBoy)}>
                          {serviceBoy.name}
                        </button>
                      </li>
                    ))
                  ) : (
                    <li>
                      <span className="dropdown-item">No Delivery Available</span>
                    </li>
                  )}
                </ul>
              </div>
            </div>

            <DataTable
              columns={columns}
              data={selectedserviceboy ? filteredLeads : leads}
              pagination
              paginationRowsPerPageOptions={[50, 100, 200, 300, 400]}
              responsive
              customStyles={{
                headRow: { style: { backgroundColor: "#E2E8F0", color: "#475569", fontWeight: "bold" } },
                pagination: { style: { borderTop: "1px solid #ddd", padding: "10px", backgroundColor: "#f8f9fa" } },
                cells: {
                  style: {
                    padding: "10px",
                    margin: "0",
                  },
                },

                headCells: {
                  style: {
                    padding: "10px",
                    margin: "0",
                  },
                },
              }}
            />
          </div>
        </div>
      )}

      <div>
        <Offcanvas className="custom-offcanvas" show={showOffcanvas} onHide={() => setShowOffcanvas(false)} placement="end">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title></Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>

            {selectedLead && (
              <div className="lead-details" ref={offcanvasRef}>

                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                    <h4 className="detail_title">Service Details</h4>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                    <h4 className="detail_title">Customer Details</h4>
                  </div>
                </div>
                <hr style={{ marginBottom: 10, marginTop: 10 }} />

                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Date</h4>
                        <p className="detail_text">{selectedLead.date}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Service Type</h4>
                        <p className="detail_text">
                          {selectedLead.service_type === 0
                            ? `Free / ${selectedLead.free_service_no} Free Service`
                            : 'Paid'}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Name</h4>
                        <p className="detail_text">{selectedLead.customer_name}-{selectedLead.phone}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Vehicle Number:</h4>
                        <p className="detail_text">{selectedLead.vehicle_name}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">

                      <div className="col-4">
                        <h4 className="detail_title">Total Amount</h4>
                        <p className="detail_text">{selectedLead.total_amount || "-"}</p>
                      </div>
                      <div className="col-4">
                        <h4 className="detail_title">Payment Status</h4>
                        <p className="detail_text">{selectedLead.payment_status === 1 ? "Paid" : "Unpaid"}</p>
                      </div>

                      <div className="col-4">
                        {selectedLead.invoice ?
                          <div>
                            <h4 className="detail_title">Invoice</h4>
                            <p className="detail_text"> <Link
                              to={'https://devapi.bykit.in/storage/brands/' + `${selectedLead.invoice}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginRight: 10 }}
                            >
                              View Invoice
                            </Link></p></div> : null
                        }
                      </div>

                    </div>
                  </div>

                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-12">
                        <h4 className="detail_title">Address</h4>
                        <p className="detail_text">{selectedLead.address}</p>
                      </div>

                    </div>
                  </div>
                </div>



                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Pickup/Drop</h4>
                        <div className="mt-2">
                          <span className="btn droppickup_btn btn-sm">
                            {selectedLead?.pickup_drop_facility === 0
                              ? "Pickup"
                              : selectedLead?.pickup_drop_facility === 3
                                ? "Self Pickup/Drop"
                                : selectedLead?.pickup_drop_facility === 1
                                  ? "Drop"
                                  : "Pickup & Drop"}
                          </span>
                        </div>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Pickup/drop Charges </h4>
                        <p className="detail_text">{selectedLead.pickupdrop_price ? selectedLead.pickupdrop_price : 'N/A'}</p>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">

                      </div>
                      <div className="col-6">

                      </div>
                    </div>
                  </div>
                </div>


                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Pickup Time</h4>
                        <p className="detail_text">{formattedPickupTime}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Pickup Images</h4>
                        <div className="d-flex flex-wrap">
                          {selectedLead.pickup_photos && selectedLead.pickup_photos.split(",").map((photo, index) => (
                            <div style={{ fontSize: 12, width: '45%' }}>
                              {labels[index] || `Photo ${index + 1}`}
                              <Link
                                key={index}
                                to={`${imageUrl}${photo}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginRight: 10 }}
                              >
                                <img
                                  src={`${imageUrl}${photo}`}
                                  alt=""
                                  className="pick_photo"
                                  onError={(e) => (e.target.style.display = "none")}
                                />
                              </Link>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <h4 className="detail_title">Vehicle Details</h4>
                      <hr style={{ marginBottom: 10, marginTop: 10 }} />
                      <div className="col-4">
                        <h4 className="detail_title">Vehicle Number</h4>
                        <p className="detail_text">{selectedLead.vehicle_name}</p>
                      </div>
                      <div className="col-4">
                        <h4 className="detail_title">Brand</h4>
                        <p className="detail_text">  {selectedLead?.brand_logo && (
                          <img
                            src={selectedLead.brand_logo}
                            alt="Brand Logo"
                            style={{ width: 50, height: 50, objectFit: "contain", marginRight: 10 }}
                            onError={(e) => (e.target.style.display = "none")}
                          />
                        )}
                        </p>
                      </div>

                      <div className="col-4">
                        <h4 className="detail_title">Model</h4>
                        <p className="detail_text">{selectedLead.model_name}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Workshop Reaching Time</h4>
                        <p className="detail_text">{formattedreachedTime}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Drop to workshop</h4>
                        <div className="d-flex flex-wrap">
                          {selectedLead.receive_photo && selectedLead.receive_photo.split(",").map((photo, index) => (
                            <div style={{ fontSize: 12, width: '45%' }}>
                              {labels[index] || `Photo ${index + 1}`}
                              <Link
                                key={index}
                                to={`${imageUrl}${photo}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginRight: 10 }}
                              >
                                <img
                                  src={`${imageUrl}${photo}`}
                                  alt=""
                                  className="pick_photo"
                                  onError={(e) => (e.target.style.display = "none")}
                                />
                              </Link>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Insurance Number</h4>
                        <p className="detail_text"> {selectedLead.insurance_number || "-"}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Insurance Company</h4>
                        <p className="detail_text"> {selectedLead.insurance_company || "-"}</p>
                      </div>
                    </div>
                  </div>
                </div>


                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Service Started Time</h4>
                        <p className="detail_text">{formattestartTime}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Service Complete Time</h4>
                        <p className="detail_text">{formattecompleteTime}</p>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      {selectedLead.insurance_copy_image ?
                        <div className="col-6">
                          <h4 className="detail_title">Insurance</h4>
                          <Link to={imageUrl + selectedLead.insurance_copy_image} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>View Attachment</Link>
                        </div>
                        : null}
                      <div className="col-6">
                        <h4 className="detail_title">Insurance Expiry Date</h4>
                        <p className="detail_text">{insuranceexpiry != '01-01-1970' ? insuranceexpiry : "-"}</p>
                      </div>
                    </div>
                  </div>
                </div>








                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Pickup from workshop</h4>
                        <p className="detail_text"> {selectedLead.work_complete_photo && selectedLead.work_complete_photo.split(",").map((photo, index) => (
                          <div style={{ fontSize: 12, width: '45%' }}>
                            {labels[index] || `Photo ${index + 1}`}
                            <Link
                              key={index}
                              to={`${imageUrl}${photo}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginRight: 10 }}
                            >
                              <img
                                src={`${imageUrl}${photo}`}
                                alt=""
                                className="pick_photo"
                                onError={(e) => (e.target.style.display = "none")}
                              />
                            </Link>
                          </div>
                        ))}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Drop to customer</h4>
                        <p className="detail_text">{selectedLead.delivery_complete_photo && selectedLead.delivery_complete_photo.split(",").map((photo, index) => (
                          <div style={{ fontSize: 12, width: '45%' }}>
                            {labels[index] || `Photo ${index + 1}`}
                            <Link
                              key={index}
                              to={`${imageUrl}${photo}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginRight: 10 }}
                            >
                              <img
                                src={`${imageUrl}${photo}`}
                                alt=""
                                className="pick_photo"
                                onError={(e) => (e.target.style.display = "none")}
                              />
                            </Link>
                          </div>
                        ))}</p>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      {selectedLead.rc_book_image && selectedLead.rc_book_image != 'https://devapi.bykit.in/blank-image.png'?
                        <div className="col-12">
                          <h4 className="detail_title">RC Book:</h4>
                          <Link to={imageUrl + selectedLead.rc_book_image} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>View Attachment</Link>
                        </div> : null}

                    </div>
                  </div>
                </div>




                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-12">
                        <h4 className="detail_title">Drop Time</h4>
                        <p className="detail_text">{formatteDropTime}</p>
                      </div>
                      <div className="col-12">
                        <h4 className="detail_title">Message From Customer</h4>
                        <p className="detail_text">{selectedLead.message}</p>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <h4 className="detail_title" style={{ marginTop: 30 }}>Ratings</h4>
                      <hr style={{ marginBottom: 10, marginTop: 10 }} />
                      <div className="col-6">
                        <h4 className="detail_title">Ratings for Delivery Boy</h4> {selectedLead.rate_delivaryboy && Array.from({ length: 5 }, (_, i) => (
                          <span key={i} className={i < selectedLead.rate_delivaryboy ? "star filled" : "star"}>
                            {i < selectedLead.rate_delivaryboy ? '★' : '☆'}
                          </span>
                        ))}
                        {selectedLead.rate_delivaryboy ? <p className="detail_text">{selectedLead.comment_delivaryboy}</p> :
                          <p className="detail_text">No Rating given by User till now.</p>
                        }
                      </div>
                      <div className="col-6">

                        <h4 className="detail_title">Ratings for Service</h4> {selectedLead.rate_workshop && Array.from({ length: 5 }, (_, i) => (
                          <span key={i} className={i < selectedLead.rate_workshop ? "star filled" : "star"}>
                            {i < selectedLead.rate_workshop ? '★' : '☆'}
                          </span>
                        ))}
                        {selectedLead.rate_workshop ? <p className="detail_text">{selectedLead.comment_workshop}</p> :
                          <p className="detail_text">No Rating given by User till now.</p>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Offcanvas.Body>
        </Offcanvas>
      </div>




      {/* Modal */}
      {showModal && (
        <div className="modal-overlay delete-overlay">
          <div className="modal-content delete-content">
            <div className="modal-header bg-dark text-white mt-0">
              <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
            </div>
            <div className='p-3'>
              <p className='delete_text'>Are you sure, do you want to deactivate ?</p>
            </div>
            <hr className='p-0 m-0'></hr>
            <div className="modal-buttons text-end p-3">
              <button onClick={() => setShowModal(false)} className='model_dlt_btn me-3'>No</button>
              <button onClick={() => {
                // Call your function here
                console.log("Marked as Converted");
                setShowModal(false);
              }} className='model_dlt_btn'>Yes</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Report;
